// Personal rules (SuiteStyle/PersonalRules.swift) are Apple-only: they rank passages by `NLEmbedding` sentence vectors and
// have the on-device Foundation Models judge confirm them, and the web has neither. A scan here finds nothing and says
// why, so the Revise room can show the rule as "checked on your Mac" rather than "clean".
import type { StyleFinding, StyleRule, StyleText } from './linter.ts';

export const PERSONAL_RULES_APPLE_ONLY =
  'Personal rules are checked on a Mac, iPad or iPhone: finding passages like your examples needs Apple’s on-device language models, which the web doesn’t have.';

export interface PersonalRuleScan {
  findings: StyleFinding[];
  /** Why nothing was looked for (always set on the web). */
  unavailable: string;
}

/** `PersonalRules.scan`: on the web, nothing, with the reason. */
export function scanPersonalRule(_rule: StyleRule, _texts: readonly StyleText[]): PersonalRuleScan {
  return { findings: [], unavailable: PERSONAL_RULES_APPLE_ONLY };
}
